import { ScreenEnum } from '../hooks/navigation/Screens';

/** The query parameter a link names a page's tab with: `/online-shop/takeout?tab=delivery`. */
export const SCREEN_TAB_PARAM = 'tab';

/**
 * The settings pages a link can open on one of their tabs (QL22): `<path>?tab=<tab>`, e.g. the platform agent's
 * "Open Order Methods" for a delivery question opens `/online-shop/takeout?tab=delivery`. Per page: its tabs by their
 * own keys, the store useHelpers keeps the page's active tab in (getActiveTab), the catalog prefix of the tabs'
 * labels, and `aliases`: a tab's old key a link may still name, to the tab it opens. The screen guide lists each tab with its link and label in every language (scripts/screen-guide.mjs).
 * Plain data, so the screen guide's build reads it too.
 */
export const SCREEN_TABS = Object.freeze({
  [ScreenEnum.OrderSettingsTakeout]: {
    store: 'takeout_settings',
    labels: 'Views:OrderSettings:Takeout.tabs',
    tabs: ['general', 'pickup', 'delivery', 'table_ordering'],
    // Table ordering's key before PROD-724.
    aliases: { room_service: 'table_ordering' },
  },
  [ScreenEnum.OpeningHours]: {
    store: 'opening_hours',
    labels: 'Views:OpeningHours:OpeningHours:OpeningHoursView.tabs',
    tabs: ['online_shop', 'reservations', 'storefront'],
  },
  [ScreenEnum.Locations]: {
    store: 'locations',
    labels: 'Views:OpeningHours:OpeningHours:OpeningHoursView.tabs',
    tabs: ['online_shop', 'storefront'],
  },
});

/** The link that opens `path` on `tab`. */
export function screenTabLink(path, tab) {
  return `${path}?${SCREEN_TAB_PARAM}=${tab}`;
}

/**
 * The tab a link asks a page for: `?tab=` naming one of `tabs` (a dash reads as an underscore, so `table-ordering`
 * works too), or an old key `aliases` maps to one of them, else null.
 */
export function linkedTab(search, tabs, aliases = {}) {
  const asked = new URLSearchParams(search ?? '').get(SCREEN_TAB_PARAM);

  if (!asked) {
    return null;
  }

  const named = asked.trim().toLowerCase().replace(/-/g, '_');
  const tab = aliases[named] ?? named;

  return tabs.includes(tab) ? tab : null;
}
